




export default {
  methods: {
    handleClick() {
      this.$router.push('/');
    }
  }
};
